import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles((theme) => ({
  root: {
    // width: 500,
    marginLeft: theme.spacing(30),
    marginTop: theme.spacing(20)
  },
  tooltip: {
    fontSize: 14,
    background: "#333",
    borderRadius: 0,
    padding: "6px 10px",
    maxWidth: 300
  },
  arrow: {
    color: "#333"
  },
  button: {
    color: "#333"
  }
}));

export default function Tooltips({
  position,
  text,
  textLimit,
  children,
  open // to show the tooltip
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Tooltip
        title={text.length > textLimit ? text.substring(0, textLimit) + '...' : text}
        placement={position}
        arrow
        // open={open}
        classes={{
          tooltip: classes.tooltip,
          arrow: classes.arrow
        }}
      >
        {children || <Button className={classes.button}>hover mouse pointer to see the tooltip</Button>}
      </Tooltip>
    </div>
  );
}

Tooltips.propTypes = {
  position: PropTypes.oneOf(["right", "left", "top", "bottom"]),
  text: PropTypes.string,
  open: PropTypes.bool,
  textLimit: PropTypes.number,
  children: PropTypes.node
};

Tooltips.defaultProps = {
  position: "bottom",
  text: "Tooltip",
  open: false,
  textLimit: 200,
};